import fetcher from 'api/fetcher';
import { getAllSourcesChecked, sourcesConfigFromDto } from 'utils/campaign';
import { SourceConfigDto } from 'utils/campaign/requirementUtils/types';
import { getSourcesByUnknownAge } from 'utils/clickme';
import { BANNER_IMAGE_CROP_DEFAULT, BannerImageCropType } from 'utils/constants/banner';
import { CampaignProcess, CampaignSource, isSecondStep, isThirdStep } from 'utils/constants/campaign';
import Debug from 'utils/debug';

import { Action } from 'store/createReducer';
import { setCampaignAllSources, setCampaignSubSource, setSourcesConfig } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const loadSourceFormConfig = (): AppThunkAction => {
    return async (dispatch, getState) => {
        const createBanner = getState().createBanner;

        const { currentStep, campaignProcess, savedSources, adUnknownAge, campaignId } = getState().createCampaign;
        const isEditCampaignProcess = campaignProcess === CampaignProcess.Edit;
        const isCreateCampaignProcess = campaignProcess === CampaignProcess.Create;
        const isLastStep = (isEditCampaignProcess && isSecondStep(currentStep)) || isThirdStep(currentStep);

        if (!isLastStep) {
            return;
        }

        try {
            const { bannerVacancyId, images } = createBanner;
            const currentImageId = images[BANNER_IMAGE_CROP_DEFAULT].id;

            if (!currentImageId) {
                return;
            }

            const params = {
                apiSourceOriginalImageId: {
                    [CampaignSource.HH]: images[BannerImageCropType.HH].id,
                    [CampaignSource.Yandex]: images[BannerImageCropType.YandexAndVK].id,
                    [CampaignSource.VKAds]: images[BannerImageCropType.VK].id,
                },
                ...(bannerVacancyId ? { vacancyId: bannerVacancyId } : {}),
            };

            const result = await fetcher.post<unknown, SourceConfigDto[]>(
                isEditCampaignProcess && campaignId
                    ? `/api/v1/source_form_config/existing_campaign?campaignId=${campaignId}`
                    : '/api/v1/source_form_config/new_campaign',
                params
            );

            if (!result) {
                return;
            }

            const { originalSourcesConfig, enabledSources } = sourcesConfigFromDto(result);

            const actions: Action[] = [setSourcesConfig(originalSourcesConfig)];

            const allSourcesChecked = getAllSourcesChecked(savedSources, enabledSources);

            if (isCreateCampaignProcess) {
                actions.push(setCampaignAllSources(true));
                actions.push(setCampaignSubSource(getSourcesByUnknownAge(enabledSources, adUnknownAge)));
            } else {
                actions.push(setCampaignAllSources(allSourcesChecked));
            }

            dispatch(actions);
        } catch (e) {
            Debug.log('error out', 'sources config error', { message: (e as Error)?.message });
        }
    };
};
